import {
  FilterType,
  buildPerformanceInsightsSummaryDatatableFilter,
  usePerformanceInsightsSummaryDatatable,
} from 'generated/resources/datatable.graphql'
import { AnalyticsPageGendersFragment } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

const gendersFilter = (
  source: ReturnType<typeof usePerformanceInsightsSummaryDatatable>,
  genders: AnalyticsPageGendersFragment[]
) => {
  return buildPerformanceInsightsSummaryDatatableFilter(source, {
    title: i18n.t('performance_process.analytics.datatable.filters.gender'),
    path: 'gender',
    identifier: 'genderIds',
    type: FilterType.String,
    default: true,
    categories: [
      {
        kind: 'MultipleChoice',
        operation: 'in',
        options: genders.map(({ translatedName, name }) => ({
          label: translatedName,
          value: name,
        })),
      },
    ],
    onUpdateValue(value) {
      track(trackingEvents.performanceAnalytics.insightsSummaryFilterApplied, {
        type: 'genderIds',
        value,
      })
    },
  })
}

export default gendersFilter
